import React, { Component } from 'react';

// Va en una constante porque en JSX las llaves y el signo menor que se interpretan como código.
const speakerFlow = `NAVEGADOR (React)                         SERVIDOR (ASP.NET Core)

1. Lista, ruta /speakers
Speakers.componentDidMount() y cada 5 segundos
  |
  v
SpeakerService: api.speakers.list()
  |
  v
callApi(): espera de 30 a 1500 ms y llama a fetch
  |
  +--- GET /api/speaker --------------->  SpeakerController.Get()
                                            |
                                            v
                                          Speakers.SpeakersGet()
                                          lista en memoria, 3 conferencistas
                                            |
  +<-- JSON con los conferencistas ---------+
  |
  v
SpeakerList -> SpeakerItem: una fila por conferencista

2. Crear, ruta /speaker
SpeakerForm: cada cambio actualiza el estado
  |
  +--> SpeakerView: vista previa mientras se escribe
  |
  v
Botón "Guardar" -> api.speakers.create()
  |
  +--- POST /api/speaker -------------->  SpeakerController.Post() -> true
  |
  v
Vuelve a /speakers

3. Editar y eliminar, ruta /speakeredit/:idspeaker
Cargar     GET    /api/speaker/{id} -> Get(id)    -> conferencista
Guardar    PUT    /api/speaker      -> Put()      -> true
Eliminar   DELETE /api/speaker/{id} -> Delete(id) -> true`;

export class Home extends Component {
  static displayName = Home.name;

  render () {
    return (
      <div>
        <h1>Conferencistas</h1>
        <p>
          Aplicación web para administrar conferencistas: lista, creación, edición y eliminación.
          Integra una interfaz en React con una API REST en ASP.NET Core en una sola solución.
        </p>

        <h2>Tecnologías</h2>
        <ul>
          <li><strong>Plantilla:</strong> ASP.NET Core con React, de .NET Core 3.1, migrada a .NET 8.</li>
          <li><strong>Servidor:</strong> ASP.NET Core sobre .NET 8 con controladores de API.</li>
          <li>
            <strong>Cliente:</strong> React 16.12, React Router 5.1, reactstrap 8.4 y Bootstrap 4.4,
            sobre create-react-app con react-scripts 3.4.
          </li>
          <li><strong>Integración:</strong> Microsoft.<wbr />AspNetCore.<wbr />SpaServices.<wbr />Extensions.</li>
        </ul>

        <h2>Funcionalidades</h2>
        <ul>
          <li>Lista de conferencistas que se actualiza cada 5 segundos.</li>
          <li>Formulario de creación con vista previa del conferencista mientras se escribe.</li>
          <li>Edición y eliminación desde la ficha de cada conferencista.</li>
          <li>Avatares generados con Gravatar.</li>
          <li>Indicadores de carga y manejo de errores en cada vista.</li>
          <li>Servicio de API con <code>fetch</code> y una latencia simulada de 30 a 1500 ms.</li>
          <li>Navegación con React Router y rutas con parámetros.</li>
          <li>Páginas de ejemplo de contador y pronóstico del clima, disponibles por URL.</li>
        </ul>

        <h2>API</h2>
        <ul>
          <li><code>GET /api/Speaker</code>: lista los conferencistas.</li>
          <li><code>{'GET /api/Speaker/{id}'}</code>: consulta un conferencista.</li>
          <li><code>POST /api/Speaker</code>: recibe un conferencista nuevo.</li>
          <li><code>PUT /api/Speaker</code>: recibe un conferencista editado.</li>
          <li><code>{'DELETE /api/Speaker/{id}'}</code>: recibe el id del conferencista a eliminar.</li>
          <li><code>GET /api/Hash</code>: devuelve un GUID sin guiones.</li>
          <li><code>GET /weatherforecast</code>: devuelve un pronóstico aleatorio de cinco días.</li>
        </ul>
        <p>
          Los conferencistas se cargan desde una lista en memoria. Crear, editar y eliminar
          responden <code>true</code> sin guardar cambios.
        </p>

        <h2>Puertos en desarrollo</h2>
        <ul>
          <li>
            La aplicación ASP.NET Core escucha en su propio puerto: con Visual Studio e IIS Express,
            {' https://localhost:44375 '}o{' http://localhost:51497'}; con <code>dotnet run</code>,
            {' http://localhost:86'}, definido en <code>Program.cs</code>.
          </li>
          <li>
            Al arrancar, ASP.NET Core ejecuta <code>npm start</code>, que inicia el servidor de
            desarrollo de React en un segundo puerto libre, distinto en cada arranque.
          </li>
          <li>El navegador solo abre el puerto de ASP.NET Core.</li>
          <li>
            Las rutas de la API las atiende ASP.NET Core; el resto (HTML, JavaScript y CSS) lo pide
            ASP.NET Core al servidor de desarrollo de React y lo devuelve al navegador.
          </li>
          <li>Por eso se ve como una sola aplicación, aunque son dos procesos en dos puertos.</li>
        </ul>

        <h2>Puertos en despliegue</h2>
        <ul>
          <li>
            La publicación ejecuta <code>npm run build</code> y deja los archivos compilados de React
            en <code>ClientApp/build</code>, dentro de la carpeta publicada.
          </li>
          <li>
            En producción no corren el servidor de desarrollo de React ni Node.js: ASP.NET Core sirve
            la API y los archivos estáticos en un solo puerto.
          </li>
          <li>
            Con Kestrel, el puerto es 86, definido en <code>Program.cs</code>; en IIS, es el puerto
            del enlace del sitio.
          </li>
        </ul>

        <h2>Requisitos</h2>
        <ul>
          <li>.NET 8 SDK y Node.js 24.</li>
          <li>Node.js solo se necesita para desarrollar y para publicar.</li>
          <li>
            El script <code>start</code> define <code>NODE_OPTIONS=--openssl-legacy-provider</code>
            {' '}para compilar con webpack 4 en Node.js 24.
          </li>
        </ul>

        <h2>Flujo de los conferencistas</h2>
        <pre className="consola"><code>{speakerFlow}</code></pre>
      </div>
    );
  }
}
